export const addFieldToSchema = (form, field, layout) => {
  var _form$steps, _newSteps$0$layout;
  const newSteps = (_form$steps = form.steps) == null ? void 0 : _form$steps.map(step => {
    var _step$layout, _step$layout2, _step$layout3;
    return {
      ...step,
      layout: {
        ...step.layout,
        large: {
          ...(((_step$layout = step.layout) == null ? void 0 : _step$layout.large) || {}),
          items: ((_step$layout2 = step.layout) == null || (_step$layout2 = _step$layout2.large) == null || (_step$layout2 = _step$layout2.items) == null ? void 0 : _step$layout2.map(item => {
            return {
              ...item,
              row: layout.row <= item.row ? (item.row || 0) + 1 : item.row
            };
          })) || ((_step$layout3 = step.layout) == null || (_step$layout3 = _step$layout3.large) == null ? void 0 : _step$layout3.items)
        }
      }
    };
  });
  newSteps == null || (_newSteps$0$layout = newSteps[0].layout) == null || (_newSteps$0$layout = _newSteps$0$layout.large) == null || (_newSteps$0$layout = _newSteps$0$layout.items) == null || _newSteps$0$layout.unshift(layout);
  return {
    ...form,
    fields: [field, ...(form.fields || [])],
    steps: newSteps || form.steps
  };
};
//# sourceMappingURL=add-field-to-schema.js.map